module.exports = __webpack_public_path__ + "img/railwayBroadcast2.0.2907348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/railwayBroadcast2.0.png
// module id = Cait
// module chunks = 0